<template>
  <div class="device-settings-body">
    <h1>{{deviceName}}</h1>

    <device-settings-body-section v-for="(section, index) in sections"
                                  :section="section"
                                  :values="values"
                                  :key="index"
                                  @changeValue="changeValue" />

    <div class="card-footer">
      <button class="btn btn-primary btn-round"
              @click="submit()">
        {{$t('message.generics.message.save')}}
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from "@packages/event-bus";
import DeviceSettingsBodySection from "@views/admin/devices/components/device-modal/components/sections/DeviceSettingsBodySection.vue";

export default {
  components: {
    DeviceSettingsBodySection,
  },

  props: {
    userId: {
      type: Number,
    },
  },

  data() {
    return {
      step: null,
      id: null,
      config: {},
      values: {},
      deviceName: null,
      sections: [
        {
          label: null,
          fields: [],
        },
      ],
    };
  },

  mounted() {
    EventBus.$on("RESET_SETTINGS_MODAL", this.load);
  },

  beforeDestroy() {
    EventBus.$off("RESET_SETTINGS_MODAL", this.load);
  },

  methods: {
    changeValue(val, model, sectionName) {
      if (!this.values[sectionName]) {
        this.$set(this.values, sectionName, {});
      }
      this.$set(this.values[sectionName], model, val);
    },
    getSelectValue(field) {
      let label = "";

      label = field.values[field.value];
      return { id: field.value, label: label };
    },
    getValuesSelect(values) {
      let valuesSelect = [];
      for (let value in values) {
        valuesSelect.push({ id: value, label: values[value] });
      }
      return valuesSelect;
    },
    reset(form) {
      if (form) {
        this.form = form;
      } else {       
        this.form = {};
      }
    },
    load(params) {
      this.reset();
      this.deviceName = params.name;
      this.id = params.id;      
      this.config = params.config;
      this.sections = [];

      for (let objSection in this.config) {
        let section = {};
        section.name = objSection;
        this.$set(this.values, section.name, {});
        let fiedlsSection = [];

        let fieldsObjSection = this.config[objSection];
        for (let objFieldSection in fieldsObjSection) {
          if (objFieldSection == "descricaoSessao") {
            section.label = fieldsObjSection[objFieldSection];
          } else {
            let field = fieldsObjSection[objFieldSection];
            field.model = objFieldSection;
            this.$set(this.values[section.name], field.model, field.value);
            fiedlsSection.push(field);
          }
        }

        section.fields = fiedlsSection;
        this.sections.push(section);
      }
    },
    parseFields() {
      for (let objSection in this.config) {
        let fieldsObjSection = this.config[objSection];
        for (let objFieldSection in fieldsObjSection) {
          if (fieldsObjSection[objFieldSection].dataType == "integer") {
            this.values[objSection][objFieldSection] = parseInt(
              this.values[objSection][objFieldSection]
            );
          }
        }
      }
    },
    async submit() {
      this.parseFields();
      await this.$api.devices.updateSettings({
        id: this.id,
        data: this.values,
        userId: this.userId,
      });
      EventBus.$emit(`LOAD_DEVICES`);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.device-settings-body {
  padding: 30px;
}

h1 {
  text-align: center;
  white-space: normal;
  line-height: normal;
}

.flex {
  align-items: center;
  justify-content: space-between;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.ips-firewall {
  width: 100%;
  text-align: center;
}
</style>
